import {paidLicensePopup} from "../../js/services/notifyMessages";
import {CustomerLicenses} from '../../js/services/customerLicenses';
import moment from "moment";

export default {
    data() {
        return {
            available_alert_ids: [],
            existing_alert_ids: [
                'xstore_license_trial_expiring',
                'xstore_license_trial_expired',
                'xstore_license_premium_expired',
                'xstore_license_enterprise_expired',
            ],
        };
    },
    mounted() {
        this.existing_alert_ids.forEach((alert_id) => {

            // Remove after 14 days
            const closed_at = window.localStorage.getItem(alert_id);
            if (closed_at && moment(closed_at).add(14, 'd').isBefore(moment())) {
                window.localStorage.removeItem(alert_id);
            }

            // Add to non dismissed alert
            if (!closed_at) this.available_alert_ids.push(alert_id)
        });
    },
    methods: {
        licensePopup(license) { return paidLicensePopup(this) },
        checkLicense($event = null, popup= false, license_code = null) {

            let currentScore = CustomerLicenses[this.$store.getters.getCustomer.license.license_meta.code];
            let desideredScore = (license_code && CustomerLicenses[license_code]) ? CustomerLicenses[license_code] : 100;
            
            if (currentScore < desideredScore) {
                if ($event) $event.preventDefault();
                if (popup) {
                    paidLicensePopup(this)
                };
                return false;
            }
            return true;
        },
        checkMenuLicense(item) {
            if (!item.disabledForLicenseCode) return true;
            return !item.disabledForLicenseCode.includes(this.$store.getters.getCustomer.license.license_meta.code);
        },
        checkLicenseOrEInvoice($event = null, popup= false) {
            if (this.$store.getters.getCustomer.license.license_meta.code === 'personal' && !this.$store.getters['services/e_invoice'].status) {
                if ($event) $event.preventDefault();
                if (popup) paidLicensePopup(this);
                return false;
            }
            return true;
        },
        isFirstDayOfLicense(license_code = null) {
            if (license_code && license_code !== this.$store.getters.getCustomer.license.license_meta.code) return false;
            return moment(this.$store.getters.getCustomer.license.activation_date).isSame(moment(), 'd');
        },
        isTrialLicenseExpiring() {
            return this.$store.getters.getCustomer.license.license_meta.code === 'trial'
                && moment(this.$store.getters.getCustomer.license.expiration_date).isBefore(moment().add(7, 'd'), 'd')
                && moment(this.$store.getters.getCustomer.license.expiration_date).isAfter(moment());
        },
        isTrialLicenseExpired(less_than = 7) {
            return this.$store.getters.getCustomer.old_license
                && this.$store.getters.getCustomer.old_license.license_meta.code === 'trial'
                && this.$store.getters.getCustomer.license.license_meta.code === 'personal'
                && moment(this.$store.getters.getCustomer.license.activation_date).add(less_than, 'd').isAfter(moment(), 'd')
                && moment(this.$store.getters.getCustomer.old_license.expiration_date).isBefore(moment());
        },
        isLicenseExpired(license, less_than = 7) {
            return this.$store.getters.getCustomer.old_license
                && this.$store.getters.getCustomer.old_license.license_meta.code === license
                && !this.checkLicense(null, false, license)
                && moment(this.$store.getters.getCustomer.license.activation_date).add(less_than, 'd').isAfter(moment(), 'd')
                && moment(this.$store.getters.getCustomer.old_license.expiration_date).isBefore(moment());
        },
        dismissLicenseAlert(alert_id) {
            window.localStorage.setItem(alert_id, moment().format());
            this.available_alert_ids = this.available_alert_ids.filter((aid) => aid !== alert_id)
        },
        reloadLicenseData() {
            this.$store.dispatch('account/login')
        },
        showMenuLicensePopup(item) {
            if (!item.disabledForLicenseCode) return true;

            if(item.disabledForLicenseCode.includes('premium')) {
                this.licensePopup('enterprise');
            } else {
                this.licensePopup('premium');
            }
        }
    },
    watch: {
        // ...
    },
    computed: {
        licenseMinStatsRange() {
            if (!this.$store.getters.getCustomer.license.data_range) return null;
            return moment().subtract(this.$store.getters.getCustomer.license.data_range).format('YYYY-MM-DD');
        },
        eInvoiceLicenseMinStatsRange() {
            if (!this.$store.getters.getCustomer.license.data_range || this.$store.getters['services/e_invoice'].status) return null;
            return moment().subtract(this.$store.getters.getCustomer.license.data_range).format('YYYY-MM-DD');
        }
    }
}
